/*eslint-disable*/
import React, { useState, useEffect, forwardRef, useRef } from "react";
import { useSelector } from "react-redux";
import SweetAlert from "react-bootstrap-sweetalert";
import { NavLink, useParams } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Pagination from "@material-ui/lab/Pagination";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import Input from "@material-ui/core/Input";
import Badge from "components/Badge/Badge.js";

// @material-ui/icons
import SaveIcon from "@material-ui/icons/Save";
import AssignmentIcon from "@material-ui/icons/Assignment";
import AddIcon from "@material-ui/icons/AddCircle";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import SearchIcon from "@material-ui/icons/Search";
import AlertIcon from "@material-ui/icons/AddAlert";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import DescriptionIcon from "@material-ui/icons/Description";
import CloseIcon from "@material-ui/icons/Close";
import PrintIcon from "@material-ui/icons/Print";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import PersonIcon from "@material-ui/icons/Person";
import PersonOutlineOutlinedIcon from "@material-ui/icons/PersonOutlineOutlined";
import DateRangeIcon from "@material-ui/icons/DateRange";
import DateRangeOutlinedIcon from "@material-ui/icons/DateRangeOutlined";
import ListAltIcon from "@material-ui/icons/ListAlt";
import MuiAlert from "@material-ui/lab/Alert";
import InputIcon from "@material-ui/icons/Input";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Table from "components/Table/Table.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";
import CustomTabs from "components/CustomTabs/CustomTabs.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import i18n from "components/Translation/Translate.js";
import Datetime from "react-datetime";
import { withNamespaces } from "react-i18next";
import { PostData } from "../../services/Request";
import { API_URL } from "services/Define";
import * as Func from "services/Function";

import styles from "assets/jss/main-style.js";

/* ========== ZONE Variable ========== */
const useStyles = makeStyles(styles);

const initAttr = {
  code: "",
  move_id: "",
  move_code: "",
  enable: "Y",
  status: "99",
  remark: "",
  date_receive: new Date(),
  store_code: "",
  branch_name: "",
  move_remark: "",
};

const initField = {
  code: "",
  product_id: "",
  product_name: "",
  unit_name: "",
  quantity: "0",
  filepic: "",
};

const initFind = {
  search: "",
  date_start: Func.dateAdd(-30),
  date_stop: new Date(),
  order_by: "tb.id",
  order_sort: "desc",
  status: "ALL",
  page: 1,
  perPage: 10,
  pageTotal: 0,
};

/* ========== ZONE Function ========== */
function RawReceive({ t }) {
  const prefix = "movereceive";
  const mod = "rawreceive";
  const classes = useStyles();

  const initHeader = [
    { code: "tb.id", name: `${prefix}.id`, order: "desc" },
    { code: "po.id", name: `${prefix}.move_id` },
    { code: "tb.date_receive", name: `${prefix}.date_receive` },
    { code: "sp.name", name: `${prefix}.branch` },
    { code: "tb.remark", name: `${prefix}.remark` },
    { code: "tb.status", name: `${prefix}.status` },
  ];
  const alignValue = [0, 2, 5, 6, 7, 8, 9];
  const alignItem = [
    classes.center,
    classes.center,
    classes.right,
    classes.center,
    classes.center,
    classes.center,
    classes.right,
  ];
  const cboPerPage = [
    { id: 10, name: "element.show_10_record" },
    { id: 20, name: "element.show_20_record" },
    { id: 100, name: "element.show_100_record" },
  ];

  const app = useSelector((state) => state.appState);
  const txtSearch = useRef(null);
  const txtSearchRef = useRef(null);
  const txtQuantity = useRef(null);
  const txtSearchList = useRef(null);

  const { id } = useParams();
  const [pageTotal, setPageTotal] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [searchRef, setSearchRef] = useState("");
  const [searchList, setSearchList] = useState("");
  const [record, setRecord] = useState([]);
  const [list, setList] = useState([]);
  const [order, setOrder] = useState([]);
  const [product, setProduct] = useState([]);
  const [ref, setRef] = useState([]);
  const [attr, setAttr] = useState(initAttr);
  const [field, setField] = useState(initField);
  const [find, setFind] = useState(initFind);
  const [header, setHeader] = useState(initHeader);
  const [alert, setAlert] = useState(null);
  const [notify, setNotify] = useState(null);
  const [tab, setTab] = useState(0);
  const [tabProduct, setTabProduct] = useState(0);
  const [modalRef, setModalRef] = useState(false);
  const [modalAdd, setModalAdd] = useState(false);
  const [modalEdit, setModalEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [cboStatus, setCboStatus] = useState([]);

  useEffect(() => {
    i18n.changeLanguage(app.lang);
    init();
  }, [id]);

  const init = () => {
    PostData(mod, "init", {
      token: app.token,
      lang: app.lang,
    }).then((result) => {
      if (result.status === "OK") {
        setCboStatus(result.stat);

        if (id === undefined) {
          view(find);
        } else if (id === "add") {
          setAttr(initAttr);
        } else {
          setTab(0);
          open();
        }
      } else {
        window.location.replace("/auth/login");
      }
    });
  };

  const changeTab = (event, value) => {
    setTab(value);
  };

  const changeTabProduct = (event, value) => {
    setTabProduct(value);
  };

  const inputChange = (e) => {
    setAttr({ ...attr, [e.target.id]: e.target.value });
  };

  const selectChange = (e) => {
    setAttr({ ...attr, [e.target.name]: e.target.value });
  };

  const checkChange = (e) => {
    setAttr({ ...attr, [e.target.name]: e.target.checked ? "Y" : "N" });
  };

  const clickPage = (e, p) => {
    page = p;
    view();
  };

  const changePerPage = (e) => {
    page = 1;
    perPage = e.target.value;
    view();
  };

  const view = (data) => {
    setLoading(true);
    PostData(mod, "view", {
      token: app.token,
      lang: app.lang,
      search: data.search,
      page: data.page,
      per_page: data.perPage,
      orderby: data.order_by,
      asc: data.order_sort,
      start: Func.dateFormat(data.date_start),
      stop: Func.dateFormat(data.date_stop),
      status: data.status,
    }).then((result) => {
      if (result.status === "OK") {
        setRecord([]);

        result.data.map((item, i) => {
          setRecord((record) => [
            ...record,
            [
              btnOpen(item),
              item.move_id,
              Func.dateDisplay(item.date_receive),
              item.branch_name,
              item.remark,
              displayStatus(item),
              btn(item),
            ],
          ]);
        });

        setPageTotal(result.total_pages);
        setPageNo(result.page);
      }
      setLoading(false);
    });
  };

  const btnOpen = (item) => {
    return (
      <NavLink to={`/admin/${mod}/${item.code}`}>
        <Button color="primary" simple>
          {item.id}
        </Button>
      </NavLink>
    );
  };

  const displayStatus = (item) => {
    return (
      <code className={`color-${item.color}`}>
        <i className={item.icon} /> {item.status_display}
      </code>
    );
  };

  const searchOrder = (e) => {
    const btnOrder = (item) => {
      return (
        <div>
          <Button
            round
            color="success"
            className={classes.actionButton + " " + classes.actionButtonRound}
            onClick={() => addList(item, 1)}
          >
            <AddIcon className={classes.icon} />
          </Button>
        </div>
      );
    };

    PostData(mod, "searchorder", {
      token: app.token,
      lang: app.lang,
      code: id,
    }).then((result) => {
      if (result.status === "OK") {
        setOrder([]);

        result.data.map((item, i) => {
          setOrder((order) => [
            ...order,
            [
              <img src={item.filepic} width="30" />,
              item.product_id,
              item.product_name,
              btnOrder(item),
            ],
          ]);
        });

        setModalAdd(true);
      }
    });
  };

  const searchProduct = (search) => {
    const btnProduct = (item) => {
      return (
        <div>
          <Button
            round
            color="success"
            className={classes.actionButton + " " + classes.actionButtonRound}
            onClick={() => addList(item, 2)}
          >
            <AddIcon className={classes.icon} />
          </Button>
        </div>
      );
    };
    setProduct([]);
    setSearchList(search);

    PostData(mod, "searchproduct", {
      token: app.token,
      lang: app.lang,
      search: search,
    }).then((result) => {
      if (result.status === "OK") {
        result.data.map((item, i) => {
          setProduct((product) => [
            ...product,
            [
              <img src={item.filepic} width="30" />,
              <div className={classes.textWrap}>{item.name}</div>,
              item.quantity,
              item.unit_name,
              btnProduct(item),
            ],
          ]);
        });
      }
    });
  };

  const loadRef = (search) => {
    const btnRef = (item) => {
      return (
        <div>
          <Button
            round
            color="success"
            className={classes.actionButton + " " + classes.actionButtonRound}
            onClick={() => addRef(item)}
          >
            <AddIcon className={classes.icon} />
          </Button>
        </div>
      );
    };

    PostData(mod, "searchref", {
      token: app.token,
      lang: app.lang,
      search: search,
    }).then((result) => {
      if (result.status === "OK") {
        setRef([]);

        result.data.map((item, i) => {
          setRef((ref) => [
            ...ref,
            [item.id, item.branch_name, item.date_record, btnRef(item)],
          ]);
        });
      }
    });
  };

  const addRef = (item) => {
    setAttr({
      ...attr,
      move_code: item.code,
      move_id: item.id,
      branch_name: item.branch_name,
    });

    setModalRef(false);
  };

  const addList = (item, kind = 1) => {
    PostData(mod, "addlist", {
      token: app.token,
      lang: app.lang,
      code: id,
      data: {
        receive_code: id,
        list_code: item.code,
        quantity: 0,
        product_code: item.product_code,
        kind: kind,
      },
    }).then((result) => {
      if (result.status === "OK") {
        setModalAdd(false);
        openList(result.code);
        open();
        showNotify(t("alert.addcomplete"), "success");
      }
    });
  };

  const editList = () => {
    PostData(mod, "editlist", {
      token: app.token,
      lang: app.lang,
      code: field.code,
      data: {
        quantity: field.quantity,
      },
    }).then((result) => {
      if (result.status === "OK") {
        open();
        setModalEdit(false);
        showNotify(t("alert.editcomplete"), "success");
      }
    });
  };

  const btnList = (item, status) => {
    if (status == 0) {
      return (
        <div>
          <Button
            round
            color="success"
            className={classes.actionButton + " " + classes.actionButtonRound}
            onClick={() => openList(item.code)}
          >
            <EditIcon className={classes.icon} />
          </Button>
          <Button
            round
            color="danger"
            className={classes.actionButton + " " + classes.actionButtonRound}
            onClick={() => delList(item)}
          >
            <DeleteIcon className={classes.icon} />
          </Button>
        </div>
      );
    } else {
      return null;
    }
  };

  const openList = (code) => {
    setLoading(true);
    setField(initField);

    PostData(mod, "openlist", {
      token: app.token,
      lang: app.lang,
      code: code,
    }).then((result) => {
      if (result.status === "OK") {
        setField(result.data);

        setModalEdit(true);

        txtQuantity.current.select();
      }
      setLoading(false);
    });
  };

  const delList = (item) => {
    setAlert(
      <SweetAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={t("alert.confirm_delete_title")}
        onConfirm={() => {
          PostData(mod, "dellist", {
            token: app.token,
            lang: app.lang,
            code: item.code,
            ref_code: id,
          }).then((result) => {
            setAlert(null);
            if (result.status === "OK") {
              open();
              showNotify(t("alert.deletecomplete"), "success");
            } else {
              showNotify(t("alert.deleteerror"), "danger");
            }
          });
        }}
        onCancel={() => setAlert(null)}
        confirmBtnCssClass={classes.button + " " + classes.success}
        cancelBtnCssClass={classes.button + " " + classes.danger}
        confirmBtnText={t("alert.ok")}
        cancelBtnText={t("alert.cancel")}
        showCancel
      >
        {t("alert.confirm_delete_msg")} #{item.code}
      </SweetAlert>
    );
  };

  const open = () => {
    setLoading(true);
    setAttr(initAttr);
    setList([]);

    PostData(mod, "open", {
      token: app.token,
      lang: app.lang,
      code: id,
    }).then((result) => {
      if (result.status === "OK") {
        setAttr({
          ...result.data,
          date_receive: new Date(result.data.date_receive),
        });

        result.list.map((item, i) => {
          setList((list) => [
            ...list,
            [
              i + 1,
              <img src={item.filepic} width="30" />,
              item.product_id,
              item.product_name,
              item.quantity,
              item.unit_name,
              displayKind(item.kind),
              btnList(item, result.data.status),
            ],
          ]);
        });

        setLoading(false);
      }
    });
  };

  const displayKind = (kind) => {
    if (kind === "1")
      return (
        <code className={`color-primary`}>
          <i className="fas fa-hand-holding-magic fa-fw" /> {t("element.receive_transfer")}
        </code>
      );
    else if (kind === "2")
      return (
        <code className={`color-info`}>
          <i className="fas fa-layer-plus fa-fw" /> {t("element.add_new")}
        </code>
      );
    else return null;
  };

  const checkEmpty = () => {
    let result = true;

    if (!Func.verifyLength(attr.move_id, 1)) {
      result = false;
    }

    return result;
  };

  const add = () => {
    if (!checkEmpty()) {
      showNotify(t("alert.pleaseinsert"), "danger");
    } else {
      setAlert(
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title={t("alert.confirm_add_title")}
          onConfirm={() => {
            setAlert(null);
            setLoading(true);

            PostData(mod, "add", {
              code: attr.move_code,
              data: {
                move_code: attr.move_code,
                remark: attr.remark,
                date_receive: Func.dateFormat(attr.date_receive),
              },
            }).then((result) => {
              setAlert(null);
              if (result.status === "OK") {
                showNotify(t("alert.addcomplete"), "success");
                window.location.assign(`/admin/${mod}/${result.code}`);
              } else {
                showNotify(t("alert.adderror"), "danger");
              }
            });
          }}
          onCancel={() => setAlert(null)}
          confirmBtnCssClass={classes.button + " " + classes.success}
          cancelBtnCssClass={classes.button + " " + classes.danger}
          confirmBtnText={t("alert.ok")}
          cancelBtnText={t("alert.cancel")}
          showCancel
        >
          {t("alert.confirm_add_msg")}
        </SweetAlert>
      );
    }
  };

  const edit = () => {
    if (!checkEmpty()) {
      showNotify(t("alert.pleaseinsert"), "danger");
    } else {
      setAlert(
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title={t("alert.confirm_edit_title")}
          onConfirm={() => {
            setAlert(null);
            setLoading(true);

            PostData(mod, "edit", {
              code: attr.code,
              data: {
                branch_code: attr.branch_code,
                remark: attr.remark,
                date_receive: Func.dateFormat(attr.date_receive),
              },
            }).then((result) => {
              setLoading(false);

              if (result.status === "OK") {
                open();
                showNotify(t("alert.editcomplete"), "success");
              } else {
                showNotify(t("alert.editerror"), "danger");
              }
            });
          }}
          onCancel={() => setAlert(null)}
          confirmBtnCssClass={classes.button + " " + classes.success}
          cancelBtnCssClass={classes.button + " " + classes.danger}
          confirmBtnText={t("alert.ok")}
          cancelBtnText={t("alert.cancel")}
          showCancel
        >
          {t("alert.confirm_edit_msg")} #{attr.code}
        </SweetAlert>
      );
    }
  };

  const copy = () => {
    if (!checkEmpty()) {
      showNotify(t("alert.pleaseinsert"), "danger");
    } else {
      setAlert(
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title={t("alert.confirm_add_title")}
          onConfirm={() => {
            setAlert(null);
            setLoading(true);

            PostData(mod, "copy", {
              ref_code: id,
              data: {
                move_code: attr.move_code,
                branch_code: attr.branch_code,
                remark: attr.remark,
                date_receive: Func.dateFormat(attr.date_receive),
              },
            }).then((result) => {
              setAlert(null);
              if (result.status === "OK") {
                showNotify(t("alert.addcomplete"), "success");
                window.location.assign(`/admin/${mod}/${result.code}`);
              } else {
                showNotify(t("alert.adderror"), "danger");
              }
            });
          }}
          onCancel={() => setAlert(null)}
          confirmBtnCssClass={classes.button + " " + classes.success}
          cancelBtnCssClass={classes.button + " " + classes.danger}
          confirmBtnText={t("alert.ok")}
          cancelBtnText={t("alert.cancel")}
          showCancel
        >
          {t("alert.confirm_add_msg")}
        </SweetAlert>
      );
    }
  };

  const print = (code) => {
    window.open(`${API_URL}/app/print/${mod}-${code}.pdf`, "_blank");
  };

  const showNotify = (msg, color) => {
    setNotify(
      <Snackbar
        place="tr"
        color={color}
        icon={AlertIcon}
        message={msg}
        open={true}
        closeNotification={() => setNotify(null)}
        close
      />
    );

    setTimeout(function () {
      setNotify(null);
    }, 3000);
  };

  const btn = (item) => {
    return (
      <>
        <NavLink to={`/admin/${mod}/${item.code}`}>
          <Button color="success" className={classes.actionButton}>
            {t(`element.open`)} <InputIcon />
          </Button>
        </NavLink>
        <Button
          color="info"
          className={classes.actionButton}
          onClick={() => print(item.code)}
        >
          {t(`element.print`)} <PrintIcon />
        </Button>
      </>
    );
  };

  const editStatus = (key) => {
    setAlert(
      <SweetAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={t("alert.confirm_edit_title")}
        onConfirm={() => {
          setAlert(null);
          setLoading(true);

          PostData(mod, "edit", {
            code: id,
            data: {
              status: key,
            },
          }).then((result) => {
            setAlert(null);

            if (result.status === "OK") {
              open();
              setAlert(null);
              showNotify(t("alert.editcomplete"), "success");
            } else {
              showNotify(t("alert.editerror"), "danger");
            }
          });
        }}
        onCancel={() => setAlert(null)}
        confirmBtnCssClass={classes.button + " " + classes.success}
        cancelBtnCssClass={classes.button + " " + classes.danger}
        confirmBtnText={t("alert.ok")}
        cancelBtnText={t("alert.cancel")}
        showCancel
      >
        {t("alert.confirm_edit_msg")} #{attr.code}
      </SweetAlert>
    );
  };

  const btnAddList = () => {
    if (attr.status < 1) {
      return (
        <Button round color="info" size="sm" onClick={() => searchOrder()}>
          <AddIcon className={classes.icon} /> {t("element.add")}
        </Button>
      );
    } else {
      return null;
    }
  };

  const renderHeader = (data) => {
    let icon = <i className="fas fa-sort"></i>;
    if (data.order === "desc") {
      icon = <i className="fad fa-sort-up"></i>;
    } else if (data.order === "asc") {
      icon = <i className="fad fa-sort-down"></i>;
    } else {
      icon = <i className="fad fa-sort"></i>;
    }

    if (data.sort === undefined || data.sort)
      return (
        <div
          onClick={() => {
            let tmp = [];
            header.map((item, i) => {
              if (data.code === item.code) {
                const ordersort = item.order === "asc" ? "desc" : "asc";
                view({ ...find, order_sort: ordersort, order_by: data.code });
                setFind({
                  ...find,
                  order_sort: ordersort,
                  order_by: data.code,
                });
                tmp[i] = {
                  code: item.code,
                  name: item.name,
                  order: ordersort,
                  sort: item.sort,
                };
              } else {
                tmp[i] = {
                  code: item.code,
                  name: item.name,
                  order: "",
                  sort: item.sort,
                };
              }
            });

            setHeader(tmp);
          }}
          style={{ cursor: "pointer" }}
        >
          {t(data.name)} {icon}
        </div>
      );
    else return <div>{t(data.name)}</div>;
  };

  const renderViewList = () => {
    return (
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="primary" icon>
              <CardIcon color="primary">
                <AssignmentIcon />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>{t("element.viewlist")}</h4>
            </CardHeader>
            <CardBody>
              <GridContainer className="viewlist">
                <GridItem xs={12} sm={6} md={6}>
                  <TextField
                    id="search"
                    fullWidth
                    InputProps={{
                      onChange: (e) => {
                        view({ ...find, search: e.target.value, page: 1 });
                        setFind({ ...find, search: e.target.value, page: 1 });
                      },
                      startAdornment: (
                        <InputAdornment position="start">
                          {t("element.search")} :
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                      autoComplete: "off",
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={6} md={3}></GridItem>
                <GridItem xs={12} sm={6} md={3}></GridItem>
                <GridItem xs={12} sm={6} md={3}>
                  <FormControl fullWidth>
                    <Datetime
                      timeFormat={false}
                      dateFormat="DD/MM/yyyy"
                      closeOnSelect
                      value={find.date_start}
                      onChange={(value) => {
                        view({ ...find, date_start: value, page: 1 });
                        setFind({ ...find, date_start: value, page: 1 });
                      }}
                      className={classes.center}
                      renderInput={(props) => {
                        return (
                          <TextField
                            fullWidth
                            InputProps={{
                              ...props,
                              startAdornment: (
                                <InputAdornment
                                  position="start"
                                  style={{ marginBottom: "4px" }}
                                >
                                  {t("element.start")} :
                                </InputAdornment>
                              ),
                              endAdornment: <DateRangeIcon />,
                              autoComplete: "off",
                              readOnly: true,
                            }}
                          />
                        );
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={6} md={3}>
                  <FormControl fullWidth>
                    <Datetime
                      timeFormat={false}
                      dateFormat="DD/MM/yyyy"
                      closeOnSelect
                      value={find.date_stop}
                      onChange={(value) => {
                        view({ ...find, date_stop: value, page: 1 });
                        setFind({ ...find, date_stop: value, page: 1 });
                      }}
                      className={classes.center}
                      renderInput={(props) => {
                        return (
                          <TextField
                            fullWidth
                            InputProps={{
                              ...props,
                              startAdornment: (
                                <InputAdornment
                                  position="start"
                                  style={{ marginBottom: "4px" }}
                                >
                                  {t("element.stop")} :
                                </InputAdornment>
                              ),
                              endAdornment: <DateRangeIcon />,
                              autoComplete: "off",
                              readOnly: true,
                            }}
                          />
                        );
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={6} md={3}>
                  <FormControl fullWidth>
                    <Select
                      value={find.status}
                      onChange={(e) => {
                        view({ ...find, status: e.target.value, page: 1 });
                        setFind({ ...find, status: e.target.value, page: 1 });
                      }}
                    >
                      <MenuItem
                        classes={{
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelected,
                        }}
                        value="ALL"
                      >
                        {t(`${prefix}.status`)}
                      </MenuItem>
                      {cboStatus &&
                        cboStatus.map((item) => (
                          <MenuItem
                            key={item.code}
                            classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected,
                            }}
                            value={item.code}
                          >
                            {item.name}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12}>
                  <Table
                    striped
                    hover
                    tableHead={[
                      renderHeader(header[0]),
                      renderHeader(header[1]),
                      renderHeader(header[2]),
                      renderHeader(header[3]),
                      renderHeader(header[4]),
                      renderHeader(header[5]),
                      <NavLink to={`/admin/${mod}/add`}>
                        <Button
                          color="primary"
                          className={classes.actionButton}
                          block
                        >
                          {t(`element.add`)}
                          <AddIcon />
                        </Button>
                      </NavLink>,
                    ]}
                    tableData={record}
                    customHeadClassesForCells={alignValue}
                    customHeadCellClasses={alignItem}
                    customClassesForCells={alignValue}
                    customCellClasses={alignItem}
                    coloredColls={[5]}
                    colorsColls={["primary"]}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={6} md={4} lg={3}>
                  <FormControl fullWidth className={classes.selectFormControl}>
                    <InputLabel className={classes.selectLabel}></InputLabel>
                    <Select
                      value={find.perPage}
                      onChange={(e) => {
                        view({
                          ...find,
                          page: 1,
                          perPage: e.target.value,
                          page: 1,
                        });
                        setFind({
                          ...find,
                          page: 1,
                          perPage: e.target.value,
                          page: 1,
                        });
                      }}
                    >
                      {cboPerPage &&
                        cboPerPage.map((item) => (
                          <MenuItem
                            key={item.id}
                            classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected,
                            }}
                            value={item.id}
                          >
                            {t(item.name)}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </GridItem>
                <GridItem
                  xs={12}
                  sm={6}
                  md={8}
                  lg={9}
                  className={classes.right}
                >
                  <Pagination
                    style={{ float: "right", marginTop: "20px" }}
                    count={pageTotal}
                    showFirstButton
                    showLastButton
                    page={pageNo}
                    onChange={(e, p) => {
                      view({ ...find, page: p });
                      setFind({ ...find, page: p });
                    }}
                  />
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  };

  const renderViewList_ = () => {
    return (
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="primary" icon>
              <CardIcon color="primary">
                <AssignmentIcon />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>{t("element.viewlist")}</h4>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} sm={6}>
                  <TextField
                    inputRef={txtSearch}
                    style={{ margin: "10px 0 0 10px" }}
                    id="search"
                    InputProps={{
                      onChange: () => view(),
                      startAdornment: (
                        <InputAdornment position="start">
                          {t("element.search")} :
                        </InputAdornment>
                      ),
                      autoComplete: "off",
                    }}
                  />
                  <Button
                    color="white"
                    justIcon
                    round
                    className={classes.searchButton}
                  >
                    <SearchIcon
                      className={
                        classes.headerLinksSvg + " " + classes.searchIcon
                      }
                    />
                  </Button>
                </GridItem>
                <GridItem xs={12} sm={6} className={classes.right}></GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12}>
                  <Table
                    striped
                    hover
                    tableHead={[
                      t(`${prefix}.id`),
                      t(`${prefix}.po`),
                      t(`${prefix}.date_receive`),
                      t(`${prefix}.branch`),
                      t(`${prefix}.remark`),
                      t(`${prefix}.status`),
                      <NavLink to={`/admin/${mod}/add`}>
                        <Button round color="info" size="sm">
                          <AddIcon className={classes.icon} />{" "}
                          {t("element.add")}
                        </Button>
                      </NavLink>,
                    ]}
                    tableData={record}
                    customHeadClassesForCells={[0, 1, 4, 5, 6]}
                    customHeadCellClasses={[
                      classes.center,
                      classes.center,
                      classes.right,
                      classes.center,
                      classes.center,
                    ]}
                    customClassesForCells={[0, 1, 4, 5, 6]}
                    customCellClasses={[
                      classes.center,
                      classes.center,
                      classes.right,
                      classes.center,
                      classes.center,
                    ]}
                    coloredColls={[]}
                    colorsColls={[]}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={4} md={3} lg={2}>
                  <FormControl fullWidth className={classes.selectFormControl}>
                    <InputLabel className={classes.selectLabel}></InputLabel>
                    <Select value={perPage} onChange={changePerPage}>
                      {cboPerPage &&
                        cboPerPage.map((item) => (
                          <MenuItem
                            key={item.id}
                            classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected,
                            }}
                            value={item.id}
                          >
                            {t(item.name)}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </GridItem>
                <GridItem
                  xs={12}
                  sm={8}
                  md={9}
                  lg={10}
                  className={classes.right}
                >
                  <Pagination
                    style={{ float: "right", marginTop: "20px" }}
                    count={pageTotal}
                    showFirstButton
                    showLastButton
                    page={pageNo}
                    onChange={clickPage}
                  />
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  };

  const renderAdd = () => {
    return (
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardBody className={classes.right}>
              <NavLink to={`/admin/${mod}`}>
                <Button color="warning">
                  <ArrowBackIcon /> {t("element.back")}
                </Button>
              </NavLink>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="primary" icon>
              <CardIcon color="primary">
                <AssignmentIcon />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>{t("element.adddata")}</h4>
            </CardHeader>
            <CardBody>
              {renderInfo()}

              <GridContainer>
                <GridItem xs={12} className={classes.right}>
                  <Button color="success" onClick={add}>
                    <SaveIcon /> {t("element.save")}
                  </Button>
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  };

  const renderEdit = () => {
    return (
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardBody>
              <GridContainer>
                <GridItem xs={6}>
                  <h4>
                    {t(`${prefix}.id`)} : {attr.id}
                  </h4>
                </GridItem>
                <GridItem xs={6} className={classes.right}>
                  <NavLink to={`/admin/${mod}`}>
                    <Button color="warning">
                      <ArrowBackIcon /> {t("element.back")}
                    </Button>
                  </NavLink>
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12}>{renderStatus()}</GridItem>
        <GridItem xs={12}>
          <CustomTabs
            headerColor="primary"
            value={tab}
            changeValue={changeTab}
            tabs={[
              {
                tabName: t("element.info"),
                tabIcon: DescriptionIcon,
                tabContent: (
                  <div>
                    {renderInfo()}
                    <GridContainer>
                      <GridItem xs={12} className={classes.right}>
                        {attr.status <= 1 ? (
                          <Button color="success" onClick={edit}>
                            <SaveIcon /> {t("element.save")}
                          </Button>
                        ) : null}
                        {attr.status <= 4 ? (
                          <Button color="info" onClick={() => print(attr.code)}>
                            <PrintIcon /> {t("element.print")}
                          </Button>
                        ) : null}
                        <Button color="info" onClick={copy}>
                          <FileCopyIcon /> {t("element.copy")}
                        </Button>
                        {attr.status <= 2 ? (
                          <Button color="danger" onClick={() => editStatus(9)}>
                            <CancelIcon /> {t("element.cancel")}
                          </Button>
                        ) : null}
                      </GridItem>
                    </GridContainer>
                  </div>
                ),
              },
              {
                tabName: t("element.order"),
                tabIcon: ListAltIcon,
                tabContent: renderOrder(),
              },
            ]}
          />
        </GridItem>
        <GridItem xs={12}>{renderDetail()}</GridItem>
      </GridContainer>
    );
  };

  const renderOrder = () => {
    return (
      <GridContainer>
        <GridItem xs={12}>
          <Table
            striped
            hover
            tableHead={[
              t(`${prefix}.num`),
              t(`${prefix}.image`),
              t(`${prefix}.product_id`),
              t(`${prefix}.product_name`),
              t(`${prefix}.quantity`),
              t(`${prefix}.unit`),
              t("field.type"),
              btnAddList(),
            ]}
            tableData={list}
            customHeadClassesForCells={[0, 1, 4, 5, 6]}
            customHeadCellClasses={[
              classes.center,
              classes.center,
              classes.right,
              classes.center,
              classes.center,
            ]}
            customClassesForCells={[0, 1, 4, 5, 6]}
            customCellClasses={[
              classes.center,
              classes.center,
              classes.right,
              classes.center,
              classes.center,
            ]}
            coloredColls={[4]}
            colorsColls={["primary"]}
          />
        </GridItem>
        <GridItem xs={12}>
          <p></p>
        </GridItem>
        <GridItem xs={12} className={classes.center}>
          {attr.status == 0 && list.length > 0 ? (
            <Button color="success" onClick={() => editStatus(3)}>
              <CheckCircleIcon /> {t(`${prefix}.status_finish`)}
            </Button>
          ) : null}
        </GridItem>
      </GridContainer>
    );
  };

  const renderModalRef = () => {
    return (
      <Dialog
        classes={{
          root: classes.center + " " + classes.modalRoot,
          paper: classes.modal,
        }}
        open={modalRef}
        maxWidth={"sm"}
        fullWidth
        keepMounted
        onClose={() => setModalRef(false)}
        aria-labelledby="modal-slide-title"
        aria-describedby="modal-slide-description"
      >
        <DialogTitle
          id="modal-ref-title"
          disableTypography
          className={classes.modalHeader}
        >
          <Button
            justIcon
            className={classes.modalCloseButton}
            key="close"
            aria-label="Close"
            color="transparent"
            onClick={() => setModalRef(false)}
          >
            <CloseIcon className={classes.modalClose} />
          </Button>
          <h4 className={classes.modalTitle}>{t("field.rawmat_transfer_note")}</h4>
        </DialogTitle>
        <DialogContent id="modal-add" className={classes.modalBody}>
          <GridContainer>
            <GridItem xs={12}>
              <CustomInput
                labelText={t("element.search")}
                id="search_ref"
                formControlProps={{
                  fullWidth: true,
                }}
                inputProps={{
                  inputRef: txtSearchRef,
                  onChange: (e) => {
                    setSearchRef(e.target.value);
                    loadRef(e.target.value);
                  },
                  value: searchRef,
                  endAdornment: (
                    <InputAdornment position="end">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                  autoComplete: "off",
                }}
              />
            </GridItem>
            <GridItem xs={12}>
              <Table
                striped
                hover
                tableData={ref}
                customHeadClassesForCells={[2, 3]}
                customHeadCellClasses={[classes.center, classes.right]}
                customClassesForCells={[2, 3]}
                customCellClasses={[classes.center, classes.right]}
                coloredColls={[]}
                colorsColls={[]}
              />
            </GridItem>
          </GridContainer>
        </DialogContent>
      </Dialog>
    );
  };

  const renderModalAdd = () => {
    return (
      <Dialog
        classes={{
          root: classes.center + " " + classes.modalRoot,
          paper: classes.modal,
        }}
        open={modalAdd}
        maxWidth={"sm"}
        fullWidth
        keepMounted
        onClose={() => setModalAdd(false)}
        aria-labelledby="modal-slide-title"
        aria-describedby="modal-slide-description"
      >
        <DialogTitle
          id="modal-add-title"
          disableTypography
          className={classes.modalHeader}
        >
          <Button
            justIcon
            className={classes.modalCloseButton}
            key="close"
            aria-label="Close"
            color="transparent"
            onClick={() => setModalAdd(false)}
          >
            <CloseIcon className={classes.modalClose} />
          </Button>
          <h4 className={classes.modalTitle}>{attr.move_id}</h4>
        </DialogTitle>
        <DialogContent id="modal-add" className={classes.modalBody}>
          <CustomTabs
            headerColor="rose"
            value={tabProduct}
            changeValue={changeTabProduct}
            tabs={[
              {
                tabName: t("field.rawmat_transfer_in"),
                tabIcon: DescriptionIcon,
                tabContent: renderProductMove(),
              },
              {
                tabName: t("element.add_new_rawmat"),
                tabIcon: ListAltIcon,
                tabContent: renderProductAdd(),
              },
            ]}
          />
        </DialogContent>
      </Dialog>
    );
  };

  const renderProductMove = () => {
    return (
      <GridContainer>
        <GridItem xs={12}>
          <Table
            striped
            hover
            tableHead={[
              t(`${prefix}.image`),
              t(`${prefix}.product_id`),
              t(`${prefix}.product_name`),
              " ",
            ]}
            tableData={order}
            customHeadClassesForCells={[3]}
            customHeadCellClasses={[classes.right]}
            customClassesForCells={[3]}
            customCellClasses={[classes.right]}
            coloredColls={[]}
            colorsColls={[]}
          />
        </GridItem>
      </GridContainer>
    );
  };

  const renderProductAdd = () => {
    return (
      <GridContainer>
        <GridItem xs={12}>
          <CustomInput
            labelText={t("element.search")}
            id="search_order"
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              inputRef: txtSearchList,
              onChange: (e) => {
                searchProduct(e.target.value);
              },
              value: searchList,
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              ),
              autoComplete: "off",
            }}
          />
        </GridItem>
        <GridItem xs={12}>
          <Table
            striped
            hover
            tableData={product}
            customHeadClassesForCells={[]}
            customHeadCellClasses={[]}
            customClassesForCells={[2, 4]}
            customCellClasses={[classes.right, classes.right]}
            coloredColls={[2]}
            colorsColls={["primary"]}
          />
        </GridItem>
      </GridContainer>
    );
  };

  const renderModalEdit = () => {
    return (
      <Dialog
        classes={{
          root: classes.center + " " + classes.modalRoot,
          paper: classes.modal,
        }}
        open={modalEdit}
        maxWidth={"sm"}
        fullWidth
        keepMounted
        onClose={() => setModalEdit(false)}
        aria-labelledby="modal-slide-title"
        aria-describedby="modal-slide-description"
      >
        <DialogTitle
          id="modal-edit-title"
          disableTypography
          className={classes.modalHeader}
        >
          <Button
            justIcon
            className={classes.modalCloseButton}
            key="close"
            aria-label="Close"
            color="transparent"
            onClick={() => setModalEdit(false)}
          >
            <CloseIcon className={classes.modalClose} />
          </Button>
          <h4 className={classes.modalTitle}>{t("element.edit")}</h4>
        </DialogTitle>
        <DialogContent id="modal-edit" className={classes.modalBody}>
          <form autoComplete="off">
            <GridContainer>
              <GridItem xs={12} sm={4}>
                <img src={field.filepic} width="100%" />
              </GridItem>
              <GridItem xs={12} sm={8}>
                <CustomInput
                  labelText={t(`${prefix}.product_id`)}
                  id="product_id"
                  success
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    value: field.product_id,
                    disabled: true,
                  }}
                />
                <CustomInput
                  labelText={t(`${prefix}.product_name`)}
                  id="product_name"
                  success
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    value: field.product_name,
                    disabled: true,
                  }}
                />
              </GridItem>
              <GridItem xs={12}>
                <p></p>
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem xs={12}>
                <Table
                  striped
                  hover
                  tableData={[
                    [
                      <b>
                        {t(`${prefix}.quantity`)} ({field.unit_name})
                      </b>,
                      <Input
                        inputRef={txtQuantity}
                        id="quantity"
                        placeholder="0.00"
                        inputProps={{
                          "aria-label": "quantity",
                          value: field.quantity,
                        }}
                        classes={{
                          input: classes.right,
                        }}
                        color="primary"
                        fullWidth={true}
                        onChange={(e) =>
                          setField({ ...field, quantity: e.target.value })
                        }
                      />,
                    ],
                  ]}
                  customHeadClassesForCells={[1]}
                  customHeadCellClasses={[classes.right]}
                  customClassesForCells={[1]}
                  customCellClasses={[classes.right]}
                  coloredColls={[1]}
                  colorsColls={["primary"]}
                />
              </GridItem>
            </GridContainer>
          </form>
        </DialogContent>
        <DialogActions className={classes.modalFooter}>
          <Button onClick={editList} color="success">
            <SaveIcon /> {t(`element.save`)}
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const renderInfo = () => {
    return (
      <form autoComplete="off">
        <GridContainer>
          <GridItem xs={12} sm={6} md={4} lg={3}>
            <InputLabel className={classes.labelDpk}>
              {t(`${prefix}.date_receive`)}
            </InputLabel>
            <FormControl fullWidth>
              <Datetime
                timeFormat={false}
                inputProps={{ placeholder: "__/__/____" }}
                dateFormat="DD/MM/yyyy"
                closeOnSelect
                value={attr.date_receive}
                onChange={(value) => {
                  setAttr({ ...attr, date_receive: value });
                }}
                className={classes.center}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={6} md={4} lg={3}>
            <CustomInput
              labelText={
                <>
                  {t(`${prefix}.movestore`)}
                  <span className={classes.colorDanger}> *</span>
                </>
              }
              id="move_id"
              formControlProps={{
                fullWidth: true,
                onClick: () => {
                  if (id === "add") {
                    loadRef("");
                    setModalRef(true);
                    setTimeout(function () {
                      txtSearchRef.current.select();
                    }, 1000);
                  }
                },
              }}
              inputProps={{
                value: attr.move_id,
                disabled: true,
                endAdornment:
                  id === "add" ? (
                    <InputAdornment position="end">
                      <SearchIcon />
                    </InputAdornment>
                  ) : null,
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={6} md={6}>
            <CustomInput
              labelText={t(`${prefix}.branch`)}
              id="branch_name"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                value: attr.branch_name,
                disabled: true,
              }}
            />
          </GridItem>
          <GridItem xs={12}>
            <CustomInput
              labelText={t("field.remark_shipping")}
              id="move_remark"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                value: attr.move_remark,
                disabled: true,
              }}
            />
          </GridItem>
          <GridItem xs={12}>
            <CustomInput
              labelText={t("field.remark_receive")}
              id="remark"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                onChange: inputChange,
                value: attr.remark,
              }}
            />
          </GridItem>
        </GridContainer>
      </form>
    );
  };

  const renderStatus = () => {
    if (attr.status == 9) {
      return (
        <MuiAlert
          elevation={3}
          variant="filled"
          severity="error"
          style={{ marginBottom: "15px" }}
        >
          {t(`${prefix}.status_cancel`)}
        </MuiAlert>
      );
    } else if (attr.status <= 4) {
      return (
        <Stepper
          activeStep={attr.status * 1}
          alternativeLabel
          className={classes.bgTransparent}
        >
          <Step>
            <StepLabel>
              <p>
                <b>{t(`${prefix}.status_send`)}</b>
              </p>
            </StepLabel>
          </Step>
          <Step>
            <StepLabel>
              <p>
                <b>{t(`${prefix}.status_finish`)}</b>
              </p>
              <p className={classes.colorDefault}>{attr.approve_user_3}</p>
              <p className={classes.colorDefault}>{attr.approve_date_3}</p>
            </StepLabel>
          </Step>
        </Stepper>
      );
    }
  };

  const renderDetail = () => {
    return (
      <GridContainer>
        <GridItem xs={12} sm={6} md={3} lg={3}>
          <Card>
            <CardHeader icon>
              <CardIcon color="warning">
                <PersonIcon />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>{t("attr.user_create")}</h4>
            </CardHeader>
            <CardBody>
              <p className={classes.statusCenter}>{attr.user_create}</p>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3} lg={3}>
          <Card>
            <CardHeader icon>
              <CardIcon color="warning">
                <PersonOutlineOutlinedIcon />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>{t("attr.date_create")}</h4>
            </CardHeader>
            <CardBody>
              <p className={classes.statusCenter}>{attr.date_create}</p>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3} lg={3}>
          <Card>
            <CardHeader icon>
              <CardIcon color="warning">
                <DateRangeIcon />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>{t("attr.user_update")}</h4>
            </CardHeader>
            <CardBody>
              <p className={classes.statusCenter}>{attr.user_update}</p>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3} lg={3}>
          <Card>
            <CardHeader icon>
              <CardIcon color="warning">
                <DateRangeOutlinedIcon />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>{t("attr.date_update")}</h4>
            </CardHeader>
            <CardBody>
              <p className={classes.statusCenter}>{attr.date_update}</p>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  };

  const renderLoading = () => {
    return (
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  };

  const renderPage = () => {
    if (id === undefined) {
      return renderViewList();
    } else if (id === "add") {
      return renderAdd();
    } else {
      return renderEdit();
    }
  };

  /* ========== ZONE Render ========== */
  return (
    <div>
      {renderPage()}
      {renderModalAdd()}
      {renderModalEdit()}
      {renderModalRef()}
      {renderLoading()}
      {alert}
      {notify}
    </div>
  );
}

export default withNamespaces()(RawReceive);
